// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1f233770","453":"3fc6d699"}[chunkId] + ".chunk.js";
};